import React, { createContext, useContext, useMemo, useState } from 'react'
import { DISABLE_AUTO_HIDE_SIDEBAR } from '../variables'

const MenuContext = createContext(null)

const useMenu = () => {
  const context = useContext(MenuContext)
  if (!context) {
    throw new Error('useMenu must be used within a MenuProvider')
  }
  return context
}

const MenuProvider = props => {
  const [menuOpened, setMenuOpened] = useState(
    window.innerWidth < 992
      ? false
      : localStorage.getItem(DISABLE_AUTO_HIDE_SIDEBAR) === 'true'
      ? localStorage.getItem('menuOpened') === 'true'
      : false
  )

  const value = useMemo(() => [menuOpened, setMenuOpened], [menuOpened])
  return <MenuContext.Provider value={value} {...props} />
}

export { MenuProvider, useMenu }
